export default __webpack_public_path__ + "static/media/emailLogo.ba01af85.svg";